 import QrcodeDiv from '../shared/QrcodeDiv.js';
 import StampDateConverter from '../converter/StampDateConverter.js';
 import StockinfoConverter from '../converter/StockinfoConverter.js';

function PanelPickupInfo(props) {
    let startDate = new Date(props.data.Stamp_Start_Date);
    let endDate = new Date(props.data.Stamp_End_Date);
    let today = new Date();
    let Difference_In_Time = startDate.getTime() - today.getTime();
    let Difference_In_Days = Math.round(Difference_In_Time / (1000 * 3600 * 24));
    let eventname = (props.data.Event_Url_Name) ;

    return (
       <>
            {
                Difference_In_Days >= 1 &&
                <div className="effective-info">
                    <span>此二維碼將於 {Difference_In_Days} 日後生效</span>
                </div>
            }
            
            <div className="stock-info">
                <span><b>訂單資料</b></span>
                <br></br>
                {props.stock.map((item) => <StockinfoConverter data={item}></StockinfoConverter>)}
            </div>
            <div className="pickup-info">
                <span>取貨門市：{props.data.Pickup_Location}</span>
                <br></br>
                <span>門市地址：<span dangerouslySetInnerHTML={{ __html: props.data.Pickup_Adress }} /></span>
                <br></br>
                <span>訂單編號：{props.data.Invoice_no}</span>

                {eventname === "20251204_red_packet" && props.data.Stamp_Remark01 !== "" &&
                    <div>
                    <br></br>    
                        <span>訂單資料： 
                        { props.data.Stamp_Remark01 === "TC" ?
                            "需要訂製姓氏" + " - " + props.data.Stamp_Remark02 :(props.data.Stamp_Remark01 === "SC" ?"需要訂製姓氏"+ " - " + props.data.Stamp_Remark02: "不需訂製姓氏") 
                        }
                        </span>
                    </div>
                }

                <br></br>
                <br></br>
                <span className="pickup-info-fulldate">
                    <span>取貨日期由</span>
                    <StampDateConverter data={props.data.Stamp_Start_Date}></StampDateConverter>
                    <span>至</span>
                    <StampDateConverter data={props.data.Stamp_End_Date}></StampDateConverter>
                </span>
                <br></br>
            </div>
            <div className="qrcode-logo">
                <QrcodeDiv stamp_code={props.data.Stamp_Prefix + props.data.Stamp_Code} stamp_icon={props.data.Stamp_QRCode_Icon}/>
            </div>
            <div className="qrcode-location">{props.data.Pickup_Location}</div>
            <div className="qrcode-number">
                <span>{props.data.Stamp_Code}</span>
            </div>
            <div className="screencap-info">
                <span>為方便取貨，請將本頁截圖!!</span>
                <br></br>
                <br></br>
                <span>會員出示會員卡取貨可以獲取積分。</span>
            </div>
        </>
   );
 }
 
export default PanelPickupInfo;